export enum RoomControlSectionType {
  SmartTvControl = 'smart_tv_control',
  TvControl = 'tv_control',
  Chromecast = 'chromecast',
}

export enum RoomControlSectionIcon {
  Smart = 'hand-pointer',
  Tv = 'tv',
  Chromecast = 'chromecast',
}

export const ROOM_CONTROL_SECTION_CONFIG: Array<{
  type: RoomControlSectionType;
  icon: RoomControlSectionIcon;
  position: number;
}> = [
  {
    type: RoomControlSectionType.SmartTvControl,
    icon: RoomControlSectionIcon.Smart,
    position: 0,
  },
  {
    type: RoomControlSectionType.TvControl,
    icon: RoomControlSectionIcon.Tv,
    position: 1,
  },
  {
    type: RoomControlSectionType.Chromecast,
    icon: RoomControlSectionIcon.Chromecast,
    position: 2,
  },
];
